import axios from 'axios';
import api from '../lib/api';

// Reset do cliente de teste (TASK_*) no HML: o ipa-app dispara a Action do ipa-clientes-homologacao.
// Fora do HML a rota responde 404; o menu nem chega a chamar (ver canHaveTestClientReset).

const TEST_HOSTS = ['ipa-hml-app.infopriceti.com.br', 'localhost'];
const TEST_LOGIN = /^task-[a-z0-9]+(-[a-z0-9]+)*@ext\.infoprice\.co$/;

export type LastTestClientReset = {
  status: 'queued' | 'in_progress' | 'completed' | string;
  conclusion: 'success' | 'failure' | 'cancelled' | string | null;
  created_at: string;
  html_url: string;
};

export type TestClientResetState = {
  available: boolean;
  client?: string;
  lastReset?: LastTestClientReset;
};

export type TestClientResetRequested = {
  client: string;
  message: string;
  lastReset?: LastTestClientReset;
  // true quando o ipa-app recusou (409) porque já há um reset deste cliente na fila ou rodando.
  alreadyRunning?: boolean;
};

export const canHaveTestClientReset = (login: string | undefined, hostname = window.location?.hostname): boolean =>
  TEST_HOSTS.includes(hostname) && TEST_LOGIN.test(login ?? '');

export const fetchTestClientResetState = async (): Promise<TestClientResetState> => {
  const resp = await api.get<TestClientResetState>('/homologacao/reset', { expectToken: true });
  return resp.data;
};

export const requestTestClientReset = async (): Promise<TestClientResetRequested> => {
  try {
    const resp = await api.post<TestClientResetRequested>('/homologacao/reset', null, { expectToken: true });
    return resp.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 409) {
      return { ...(error.response.data as TestClientResetRequested), alreadyRunning: true };
    }
    throw error;
  }
};
